
import React from 'react';

export default function WorksSection() {
  const works = [
    {
      title: '観光・地域ブランディング',
      description: '地域の魅力を再発見し、持続可能な観光戦略を構築します。季節偏重の集客構造を見直し、通年で人が訪れる仕組みをデザイン。地元の文化や資源を活かしたブランディングを通して、地域全体の価値を高めていきます。',
      icon: 'ri-map-2-line',
      features: [
        '観光コンテンツ開発',
        '地域ブランド戦略',
        'インバウンド対応',
        'イベント企画・運営'
      ],
      image: 'https://static.readdy.ai/image/0736d0f97af205035455602030a0e7f5/2723f0bf6891ae628d3bb8c9c5a019a7.png'
    },
    {
      title: '宿泊施設運営：レドンド秋吉台',
      description: '秋吉台の大自然と光るアートが融合した、非日常体験型グランピング施設「レドンド秋吉台」を運営しています。地元食材を使ったBBQ、焚き火、満天の星空など、山口観光の拠点として家族やカップルに人気。宿泊を通じて"地域の魅力を体験として伝える"ことを目指しています。',
      icon: 'ri-tent-line',
      features: [
        '番組・動画制作',
        'SNS運用代行',
        'プレスリリース発信',
        'メディアリレーション'
      ],
      image: 'https://static.readdy.ai/image/0736d0f97af205035455602030a0e7f5/f392bb9dde86eb72e530d5346ad3a028.jpeg',
      buttonText: 'レドンド秋吉台へ',
      buttonLink: 'https://www.redondo.jp/'
    },
    {
      title: 'マーケティング支援：ローカルマーケティングラボ',
      description: 'データドリブンなアプローチで、市場分析から施策実行までを一貫してサポートします。ROI（費用対効果）を重視し、成果につながるマーケティング戦略を構築。地方企業・店舗・団体が自走できるマーケティング体制づくりを目指しています。',
      icon: 'ri-bar-chart-line',
      features: [
        '市場調査・分析',
        'デジタルマーケティング',
        '販路開拓支援',
        '効果測定・改善'
      ],
      image: 'https://static.readdy.ai/image/0736d0f97af205035455602030a0e7f5/cfbe77bc71e90b4061a005cd1b296968.png',
      buttonText: 'ローカルマーケティングラボへ',
      buttonLink: 'https://localmarketinglab.jp/'
    }
  ];

  return (
    <section className="py-32 bg-[#F8FAFC] mb-32">
      <div className="container mx-auto px-4">
        <div className="text-center mb-20">
          <p className="text-sm font-medium uppercase tracking-wider mb-6"
             style={{ color: 'rgb(11, 61, 145)' }}>
            WORKS
          </p>
          <h2 className="text-3xl lg:text-4xl font-bold text-[#111827] mb-16 leading-relaxed">
            事業コンテンツ
          </h2>
        </div>

        <div className="max-w-6xl mx-auto space-y-20">
          {works.map((work, index) => (
            <div key={index} className="bg-white rounded-2xl shadow-sm overflow-hidden">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-0">
                {/* 画像部分 */}
                <div className="relative overflow-hidden">
                  <img
                    src={work.image}
                    alt={work.title}
                    className="w-full h-80 lg:h-full object-cover"
                  />
                  <div className="absolute top-6 left-6">
                    <div className="bg-white/90 backdrop-blur-sm rounded-full p-4">
                      <div className="w-8 h-8 flex items-center justify-center">
                        <i className={`${work.icon} text-[#0B3D91] text-2xl`}></i>
                      </div>
                    </div>
                  </div>
                </div>

                {/* コンテンツ部分 */}
                <div className="p-8 lg:p-12 flex flex-col justify-center">
                  <h3 className="text-2xl font-bold text-[#111827] mb-8 leading-relaxed">
                    {work.title}
                  </h3>
                  <p className="text-gray-600 mb-10 leading-loose">
                    {work.description}
                  </p>

                  {/* 主な取り組み */}
                  <div className="mb-10">
                    <h4 className="text-lg font-semibold text-[#111827] mb-6 leading-relaxed">
                      主な取り組み
                    </h4>
                    <div className="space-y-4">
                      {work.features.map((feature, idx) => (
                        <div key={idx} className="flex items-start space-x-3">
                          <div className="w-2 h-2 bg-[#40BFB4] rounded-full mt-2 flex-shrink-0"></div>
                          <span className="text-gray-600 text-sm leading-relaxed">{feature}</span>
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* ボタン */}
                  {work.buttonText && (
                    <div>
                      <a
                        href={work.buttonLink}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center bg-[#0B3D91] text-white px-6 py-3 rounded-lg font-medium cursor-pointer hover:bg-[#0B3D91]/90 transition-colors duration-200 whitespace-nowrap"
                      >
                        {work.buttonText}
                        <div className="w-4 h-4 flex items-center justify-center ml-2">
                          <i className="ri-arrow-right-line text-sm"></i>
                        </div>
                      </a>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* お問い合わせボタン */}
        <div className="text-center mt-20">
          <a
            href="#contact"
            className="inline-flex items-center text-white px-8 py-4 rounded-lg font-medium cursor-pointer hover:opacity-90 transition-colors duration-200 whitespace-nowrap text-lg"
            style={{ backgroundColor: 'rgb(64 191 180)' }}
          >
            <div className="w-5 h-5 flex items-center justify-center mr-3">
              <i className="ri-mail-line text-lg"></i>
            </div>
            お問い合わせはこちら
          </a>
        </div>
      </div>
    </section>
  );
}
